import { HTMLElementNotFoundError } from "./errors/HtmlElementNotFoundError";

/**
 * @class ListenerHelper
 * @param {HTMLElement} modal - The modal element
 * @param {HTMLElement} axTyreMotionAllResult - The result search container
 * @param {HTMLElement} axTyreMotionTyreChoice - The tyre choice container
 */
export class ListenerHelper {
    constructor(modal, axTyreMotionAllResult, axTyreMotionTyreChoice) {
        this.resultsStepButtonsAndHandlers = [];
        this.choiceStepButtonsAndHandlers = [];
        if(!Boolean(modal)) throw new HTMLElementNotFoundError('No modal found');
        this.modal = modal;
        if(!Boolean(axTyreMotionAllResult)) throw new HTMLElementNotFoundError('No result search container found');
        this.axTyreMotionAllResult = axTyreMotionAllResult;
        if(!Boolean(axTyreMotionTyreChoice)) throw new HTMLElementNotFoundError('No tyre choice container found');
        this.axTyreMotionTyreChoice = axTyreMotionTyreChoice;
        this.hasResultSearchCLickTogglerListener = false;
    }

    addClickEventListenerResults = () => {
        const buttons = this.axTyreMotionAllResult.querySelectorAll('.btn');
        const goToWheelChoiceStepButton = this.modal.querySelector('button[data-step="wheel-choice"]')
        if(!buttons.length) throw new HTMLElementNotFoundError('No results found');

        const resultSearch = this.axTyreMotionAllResult.querySelector('#axTyreMotionResultSearch');
        if(!this.hasResultSearchCLickTogglerListener) {
            resultSearch.addEventListener('click', (event) => {
                resultSearch.classList.toggle('active');
            } );
            this.hasResultSearchCLickTogglerListener = true;
        }
        const handleClick = (event) => {
            event.stopPropagation();
            if(!Boolean(goToWheelChoiceStepButton)) throw new HTMLElementNotFoundError('No wheel choice button found');
            goToWheelChoiceStepButton.disabled = false;
            buttons.forEach((button) => button.classList.remove('active'))
            event.currentTarget.classList.toggle('active')
            resultSearch.classList.remove('active');
        };
        buttons.forEach((button) => {
            button.addEventListener('click', handleClick)
            this.resultsStepButtonsAndHandlers.push({button, handleClick});
        });
        if (buttons.length === 1) {
            buttons[0].classList.add('active');
            goToWheelChoiceStepButton.disabled = false;
        }
    }
    
    addClickEventListenerChoicePosition = () => {
        const buttons = this.axTyreMotionTyreChoice.querySelectorAll('#axTyreMotionTyreChoice .btn');
        const goToResultButton = this.modal.querySelector('button[data-step="result"]')
        if(!buttons.length) throw new HTMLElementNotFoundError('No results found');
        const imageElement = this.modal.querySelector('[data-step="wheel-choice"] img');
        if(!Boolean(imageElement)) throw new HTMLElementNotFoundError('No image element found');
        const handleClick = (event) => {
            if(!Boolean(goToResultButton)) throw new HTMLElementNotFoundError('No wheel choice button found');
            goToResultButton.disabled = false;
            imageElement.src = event.currentTarget.dataset.img;
            buttons.forEach((button) => button.classList.remove('active'));
            event.currentTarget.classList.toggle('active');
        }; 
        buttons.forEach((button) => {
            button.addEventListener('click', handleClick);
            this.choiceStepButtonsAndHandlers.push({button, handleClick});
        });
    }

    cleanResultsStep = () => {
        if(!this.resultsStepButtonsAndHandlers.length) return;
        this.resultsStepButtonsAndHandlers.forEach(({button, handleClick}) => {
            button.removeEventListener('click', handleClick);
            button.remove();
        });
        this.resultsStepButtonsAndHandlers = [];
        const goToWheelChoiceStepButton = document.querySelector('button[data-step="wheel-choice"]')
        if(Boolean(goToWheelChoiceStepButton)) {
            goToWheelChoiceStepButton.disabled = true;
        }
    }

    cleanChoicesStep = () => {
        if(!this.choiceStepButtonsAndHandlers.length) return;
        this.choiceStepButtonsAndHandlers.forEach(({button, handleClick}) => {
            button.removeEventListener('click', handleClick);
            button.remove();
        });
        this.choiceStepButtonsAndHandlers = [];
        const goToResultButton = document.querySelector('button[data-step="result"]')
        if(Boolean(goToResultButton)) {
            goToResultButton.disabled = true;
        }
    }
}